import * as types from '../constants/actionTypes';

export function setBusiesses(choices) {
    return dispatch => {
        dispatch({
            type: types.SET_BUSINESSES,
            choices: choices
        })
    }
}

export function setCurBusiness(business) {
    return dispatch => {
        dispatch({
            type: types.CURRENT_BUSINESS,
            business: business
        })
    }
}

export function setUserData(user) {
    return dispatch => {
        dispatch({
            type: types.SET_USER_DATA,
            user: user
        })
    }
}

export function setUserProfile(profile) {
    return dispatch => {
        dispatch({
            type: types.SET_USER_PROFILE,
            profile
        })
    }
}

export function toggleLoadingHandler(loading) {
    return dispatch => {
        dispatch({
            type: types.TOGGLE_LOADING,
            toggleLoading: loading
        })
    }
}

export function toggleAlertHandler(alert) {
    return dispatch => {
        dispatch({
            type: types.TOGGLE_ALERT,
            toggleAlert: alert
        })
    }
}